export const DOCUMENT = `DOCUMENT`;

/* LAYOUT */
export const GET_DOCUMENT_FORM_DATA = `${DOCUMENT}/GET_DOCUMENT_FORM_DATA`;
export const SET_DOCUMENT_FORM_DATA = `${DOCUMENT}/SET_DOCUMENT_FORM_DATA`;

export const SET_FILTER_FORM_CONFIG = `${DOCUMENT}/SET_FILTER_FORM_CONFIG`;

export const GET_DOCUMENT_NOTIFY_DATA = `${DOCUMENT}/GET_DOCUMENT_NOTIFY_DATA`;
export const SET_DOCUMENT_NOTIFY_DATA = `${DOCUMENT}/SET_DOCUMENT_NOTIFY_DATA`;

export const SET_FILTER_NOTIFY_CONFIG = `${DOCUMENT}/SET_FILTER_NOTIFY_CONFIG`;

export const GET_DOCUMENT_GUIDELINE_DATA = `${DOCUMENT}/GET_DOCUMENT_GUIDELINE_DATA`;
export const SET_DOCUMENT_GUIDELINE_DATA = `${DOCUMENT}/SET_DOCUMENT_GUIDELINE_DATA`;

export const SET_FILTER_GUIDELINE_CONFIG = `${DOCUMENT}/SET_FILTER_GUIDELINE_CONFIG`;

export const GET_DOCUMENT_DETAIL_DATA = `${DOCUMENT}/GET_DOCUMENT_DETAIL_DATA`;
export const SET_DOCUMENT_DETAIL_DATA = `${DOCUMENT}/SET_DOCUMENT_DETAIL_DATA`;

export const GET_DOCUMENTS_LINK_ACTION = `${DOCUMENT}/GET_DOCUMENTS_LINK_ACTION`;

export const GET_DOCUMENT_CATEGORIES_DATA = `${DOCUMENT}/GET_DOCUMENT_CATEGORIES_DATA`;
export const SET_DOCUMENT_CATEGORIES_DATA = `${DOCUMENT}/SET_DOCUMENT_CATEGORIES_DATA`;
